import { createContext } from 'react';

export interface GitHubAuthContextType {
  isAuthenticated: boolean;
  accessToken: string | null;
  user: { login: string; name?: string; avatar_url: string; email?: string } | null;
  login: () => void;
  logout: () => void;
  isLoading: boolean;
}

export const GitHubAuthContext = createContext<GitHubAuthContextType | undefined>(undefined);
